export interface PlanTileType {
  planName: PlanLabel
  href: string
  header: string
  subheader: string
  planLabel?: string
  planImageSrc?: string
}

export enum PlanLabel {
  PRO = 'Pro',
  PRO_PLUS = 'Pro Plus',
  ENTERPRISE = 'Enterprise',
  COMPARE = 'Compare',
  NEXT_PLAN = 'Next Plan'
}

export const COMPARE_PLANS_INDEX = 3
